const e=async(e,t,n)=>{let{data:r}=await e.get(`/apps/${t}/system-roles`,{params:n});return r};export{e as getSystemRoles};
//# sourceMappingURL=get-system-roles.mjs.map